import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useGlobalContext } from "../Config";
import ProductosDisponiblesTable from "../components/ProductosDisponiblesTable";
import UseScrollOnStateChange from "../components/UseScrollOnStateChange";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom"; // Use useLocation to get the current URL
import Loader from "../components/Loader";
import { ProgressBar } from "primereact/progressbar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import FormCrearListaEspera from "../components/FormCrearListaEspera";
import { Checkbox } from "primereact/checkbox";
import { validateFiltrosProductosCabecera } from "../utilities/Helper";



const AgregarProducto = () => {
  const [regularizarCotizacion, setRegularizarCotizacion] = useState(false);
  const [tipoProductoTouched, setTipoProductoTouched] = useState(false);
  const [desdeTouched, setDesdeTouched] = useState(false);
  const [hastaTouched, setHastaTouched] = useState(false);
  const [displayDialog, setDisplayDialog] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idCliente = parseInt(searchParams.get("idCliente"));
  const idCotizacion = parseInt(searchParams.get("idCotizacion"));
  const selected = searchParams.get("selected");
  const desdeParam = searchParams.get("desde");
  const hastaParam = searchParams.get("hasta");

  const parseYMDToLocalDate = (value) => {
    if (!value || typeof value !== "string") return null;
    const [year, month, day] = value.split("-").map(Number);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
  };

  const [desde, setDesde] = useState(parseYMDToLocalDate(desdeParam));
  const [hasta, setHasta] = useState(parseYMDToLocalDate(hastaParam));
  const [carro, setCarro] = useState([]);
  const [cliente, setCliente] = useState(null);
  const { baseUrl } = useGlobalContext();
  const [empresa, setEmpresa] = useState("TODAS");
  const empresasOptions = [
    { label: 'ALTAMIRA', value: 'ALTAMIRA' },
    { label: 'LA SIEMBRA', value: 'LA SIEMBRA' },
    { label: 'TODAS', value: 'TODAS' }
  ];
  const [showProductosEncontrados, setShowProductosEncontrados] = useState(false);
  const [tipoProducto, setTipoProducto] = useState("");
  const [tiposProducto, setTiposProducto] = useState([
    { id: 1, descripcion: "Bodega", code: "Bodega", cobro: "Factura Exenta" },
    { id: 2, descripcion: "Sitio", code: "Sitio", cobro: "Factura Exenta" },
    { id: 3, descripcion: "Casino", code: "Casino", cobro: "Factura Exenta" },
    {
      id: 4,
      descripcion: "Zona Lavado",
      code: "Zona Lavado",
      cobro: "Factura Exenta",
    },
  ]);
  const navigate = useNavigate();

  
  const [rowClick, setRowClick] = useState(true);

  const [loading, setLoading] = useState(false);
  const [productosDisponibles, setProductosDisponibles] = useState([]);
  const [displayConstruccion, setDisplayConstruccion] = useState(false);

  const searchProductos = async () => {
    try {
      if (!isValidFiltrosProductos()) {
        return;
      }

      resetCarro();
      setProductosDisponibles([]);
      const empresasArray = mapEmpresas(empresa);
      const tiposArray = mapTipos(tipoProducto);
      const { desdeFiltro, hastaFiltro } = mapDateFilters(desde, hasta);
      // Convertir las fechas a formato ISO
      //const desdeFiltro = desde ? desde.toISOString().split('T')[0] : '';
      //const hastaFiltro = hasta ? hasta.toISOString().split('T')[0] : '';
      setLoading(true);
      setShowProductosEncontrados(true);

      const url = buildProductosUrl(
        empresasArray,
        desdeFiltro,
        hastaFiltro,
        tiposArray
      );
      const data = await fetchData(url);
      handleProductosResponse(data);
    } catch (error) {
      console.error(error);
    }
  };

  const isValidFiltrosProductos = () => {
    if (!checkCabeceraFiltrosProductos()) {
      return false;
    }
    return true;
  };

  const checkCabeceraFiltrosProductos = () => {
    const { isValid, errorMessage } = validateFiltrosProductosCabecera({
      empresa,
      tipoProducto,
      desde,
      hasta,
      regularizarCotizacion,
    });

    if (errorMessage) {
      alert(errorMessage);
    }

    return isValid;
  };

  const mapEmpresas = (selectedEmpresa) => {
    const empresaMapping = {
      TODAS: ["2", "3"],
      ALTAMIRA: ["2"],
      "LA SIEMBRA": ["3"],
    };
    return empresaMapping[selectedEmpresa.toUpperCase()] || [];
  };

  const mapTipos = (tipoProductoArray) => {
    return tipoProductoArray.map((tipo) => tipo.descripcion);
  };
  const buildProductosUrl = (
    empresasArray,
    desdeFiltro,
    hastaFiltro,
    tiposArray
  ) => {
    return `${baseUrl}getProductosByFiltro?empresas=${empresasArray}&fechaInicio=${desdeFiltro}&fechaTermino=${hastaFiltro}&tipos=${tiposArray}`;
  };

  const handleProductosResponse = (data) => {
    if (Array.isArray(data.productos)) {
      setProductosDisponibles(data.productos);
      setLoading(false);
    } else {
      console.error("Data.clientes no es array:", data.clientes);
      setLoading(false);
    }
  };

  const mapDateFilters = (desde, hasta) => {
    const dateObjectDesde = new Date(desde);
    const dateObjectHasta = new Date(hasta);
    const desdeFiltro = dateObjectDesde.toISOString().split("T")[0];
    const hastaFiltro = dateObjectHasta.toISOString().split("T")[0];
    setDesdeFiltro(desdeFiltro);
    setHastaFiltro(hastaFiltro);

    return { desdeFiltro, hastaFiltro };
  };

  const [desdeFiltro, setDesdeFiltro] = useState("");
  const [hastaFiltro, setHastaFiltro] = useState("");

  const resetCarro = () => {
    setCarro([]);
  };

  const fetchDataCliente = async () => {
    try {
      const response = await fetch(
        `${baseUrl}getClienteById?idCliente=${idCliente}`
      );
      if (!response.ok) {
        throw new Error(
          `Network response was not ok. Status: ${response.status}`
        );
      }
      const data = await response.json();
      setCliente(data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  const fetchData = async (url) => {
    const requestOptions = {
      method: "GET",
      headers: new Headers(),
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(
        `Network response was not ok. Status: ${response.status}`
      );
    }

    return response.json();
  };
  useEffect(() => {
    if (idCliente) {
      fetchDataCliente();
    }
  }, [idCliente, selected]);

  const selectSubProductsAndServices = () => {
    if (carro.length <= 0) {
      alert("Seleccione al menos un producto");
    } else {
      // Update each item in carro to include tarifa_base attribute
      const updatedCarro = carro.map((item) => ({
        ...item,
        tarifa_base: item.tarifa_base,
      }));

      const carroEncoded = encodeURIComponent(JSON.stringify(updatedCarro));

      const newURL = `/selectSubProductosYServicios?activeIndex=2&selectedItems=${carroEncoded}&idCliente=${cliente.id}&selected=true&desde=${desdeFiltro}&hasta=${hastaFiltro}&idCotizacion=${idCotizacion}&adicional=true`;
      navigate(newURL, {
        state: {
          isFormAgregarProducto: true,
        },
      });
    }
  };
  UseScrollOnStateChange(productosDisponibles, "productosDataTable");
  const getTipoProductoByEmpresa = async (empresa) => {
    try {
      const url = `${baseUrl}getTiposProductoByEmpresa?empresa=${empresa}`;
      const data = await fetchData(url);
      handleTiposProductoResponse(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleTiposProductoResponse = (data) => {
    if (Array.isArray(data.tiposProductos)) {
      setTiposProducto(data.tiposProductos);
    } else {
      console.error("Data received is not an array");
    }
  };
  useEffect(() => {
    getTipoProductoByEmpresa("TODAS");
  }, []);

  const today = new Date();

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const tomorrowHasta = new Date(today);
  tomorrowHasta.setDate(tomorrowHasta.getDate() + 2);

  const canShowRegularizarCotizacion = (() => {
    if (!(desde instanceof Date) || Number.isNaN(desde.getTime())) return false;

    const desdeDate = new Date(desde);
    desdeDate.setHours(0, 0, 0, 0);

    const todayDate = new Date(today);
    todayDate.setHours(0, 0, 0, 0);

    return desdeDate <= todayDate;
  })();

  const formatDateToYMD = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <>
      {cliente && (
        <>
          <Button
            label="Volver a la Asignación"
            icon="pi pi-arrow-left"
            rounded 
            outlined 
            onClick={() => {
              const desdeFormatted = formatDateToYMD(desde);
              const hastaFormatted = formatDateToYMD(hasta);

              navigate(
                `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desdeFormatted}&hasta=${hastaFormatted}`
              );
            }}
            className="p-button mt-4 mb-4 p-button-rounded"
          />

          <ProgressBar value="100" showValue={false} className="mt-3" />
          <div  id="clienteSeleccionado" className="surface-50 border-1 border-200 border-round p-3">
            <div className="flex align-items-center mb-3">
              <span className="text-900 font-semibold" style={{ fontSize: "1rem" }}>
                Cliente seleccionado
              </span>
            </div>
            <div className="grid">
              <div className="col-12 md:col-6 lg:col-3">
                <small className="text-600 block mb-1">RUT</small>
                <div className="text-900 font-medium">{cliente?.rut || "-"}</div>
              </div>
              <div className="col-12 md:col-6 lg:col-3">
                <small className="text-600 block mb-1">Razón social</small>
                <div className="text-900 font-medium">{cliente?.razon_social || "-"}</div>
              </div>
              <div className="col-12 md:col-6 lg:col-3">
                <small className="text-600 block mb-1">Nombre fantasía</small>
                <div className="text-900 font-medium">{cliente?.nombre_fantasia || "-"}</div>
              </div>
              <div className="col-12 md:col-6 lg:col-3">
                <small className="text-600 block mb-1">Alias</small>
                <div className="text-900 font-medium">{cliente?.alias || "-"}</div>
              </div>
            </div>
          </div>
          <ProgressBar value="100" showValue={false}  />

          {/* Bloque de formulario cliente */}
          <h4 className="text-900 font-bold mt-4 mb-3">
            Agregue productos a la cotización N° {idCotizacion}
          </h4>

          <div className="card">
            <div className="grid">
              <div className="field col-12 md:col-6 mt-2">
                <label htmlFor="empresa"><i className="pi pi-th-large mr-2 text-500"></i>Empresa *</label>
                  <Dropdown
                    id="empresa"
                    value={empresa}
                    options={empresasOptions}
                    onChange={async (e) => {
                      setEmpresa(e.value);
                      setTipoProducto("");
                      await getTipoProductoByEmpresa(e.value);
                    }}
                    placeholder="Seleccione Empresa"
                    className="p-inputtext-lg w-full"
                    required
                    label="Empresa"
                    optionLabel="label"
                  />
              </div>

              <div className="field col-12 md:col-6 mt-2">
                <label htmlFor="tipoProducto"><i className="pi pi-th-large mr-2 text-500"></i>Tipo Producto *</label>
                <MultiSelect
                  id="tipoProducto"
                  value={tipoProducto}
                  onChange={(e) => {
                    setTipoProducto(e.value);
                    setTipoProductoTouched(true);
                  }}
                  onBlur={() => setTipoProductoTouched(true)}
                  options={tiposProducto
                    .filter((option, index, self) =>
                      index === self.findIndex((t) => t.descripcion === option.descripcion)
                    )
                    .map((option) => ({
                      ...option,
                      label: option.descripcion,
                    }))
                  }
                  optionLabel="label"
                  placeholder={`Seleccione Tipo Producto (${empresa})`}
                  filter
                  required
                  className={`p-inputtext-lg w-full align-items-center ${tipoProductoTouched && (!tipoProducto || tipoProducto.length === 0) ? 'p-invalid' : ''}`}
                  style={{ minHeight: "50px" }}
                />
                {tipoProductoTouched && (!tipoProducto || tipoProducto.length === 0) && (
                  <small className="p-error block mt-1">El tipo de producto es obligatorio</small>
                )}
              </div>
            </div>

            {canShowRegularizarCotizacion && (
            <div className="flex align-items-center gap-2">
              <Checkbox
                inputId="regularizarCotizacion"
                checked={!!regularizarCotizacion}
                onChange={(e) => {
                  if (typeof setRegularizarCotizacion === "function") {
                    setRegularizarCotizacion(e.checked);
                  }
                }}
              />
              <label htmlFor="regularizarCotizacion" className="cursor-pointer">
                Modo regularización (sin restricción de fechas)
              </label>
            </div>
            )}
            <div className="grid mt-2">
              <div className="field col-12 md:col-6">
                <label htmlFor="desde"><i className="pi pi-calendar mr-1 text-500"></i>Fecha de inicio *</label>
                <Calendar
                  id="desde"
                  dateFormat="dd/mm/yy"
                  showIcon
                  showButtonBar
                  value={desde}
                  onChange={(e) => {
                    setDesde(e.value);
                    setDesdeTouched(true);
                  }}
                  onBlur={() => setDesdeTouched(true)}
                  minDate={regularizarCotizacion ? null : tomorrow}
                  placeholder="Seleccione una fecha"
                  className={`p-inputtext-lg w-full ${desdeTouched && (!desde || desde === "") ? 'p-invalid' : ''}`}
                />
                {desdeTouched && (!desde || desde === "") && (
                  <small className="p-error block mt-1">El fecha de inicio es obligatorio</small>
                )}
              </div>

              <div className="field col-12 md:col-6">
                <label htmlFor="hasta"><i className="pi pi-calendar mr-2 text-500"></i>Fecha de termino *</label>
                <Calendar
                  id="hasta"
                  dateFormat="dd/mm/yy"
                  showIcon
                  showButtonBar
                  value={hasta}
                  onChange={(e) => {
                    setHasta(e.value);
                    setHastaTouched(true);
                  }}
                  onBlur={() => setHastaTouched(true)}
                  minDate={regularizarCotizacion ? null : tomorrowHasta}
                  placeholder="Seleccione una fecha"
                  className={`p-inputtext-lg w-full ${hastaTouched && (!hasta || hasta === "") ? 'p-invalid' : ''}`}
                  invalid
                  label="Fecha de termino *"
                />
                {hastaTouched && (!hasta || hasta === "") && (
                  <small className="p-error block mt-1">El fecha de termino es obligatorio</small>
                )}
              </div>
            </div>

            <div className="field col-12 md:col-12" style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  label={`Buscar Productos`}
                  icon="pi pi-search"
                  className="p-button-rounded"
                  onClick={() => {
                    searchProductos();
                  }}
                  style={{ width: "400px" }}
                  disabled={loading}
                />
              </div>
          </div>
        </>
      )}
      {showProductosEncontrados && (
        <>
          {loading ? (
            <>
              <Loader/>
            </>
          ) : (
            <div className="field col-12 md:col-12">
              <ProductosDisponiblesTable
                productosDisponibles={productosDisponibles}
                loading2={loading}
                rowClick={rowClick}
                carro={carro}
                setCarro={setCarro}
                desdeFiltro={desdeFiltro}
                hastaFiltro={hastaFiltro}
                setDisplayDialog={setDisplayDialog}
                nombreEmpresa={empresa}
              />
            </div>
          )}

          <div className="field col-12 md:col-12" style={{ display: "flex", justifyContent: "center" }}>
            <Button
              label="Agregar"
              icon="pi pi-plus"
              className="mt-4 mb-4 p-button-rounded p-button-success"
              onClick={selectSubProductsAndServices}
              style={{ width: "400px" }}
              visible={!loading}
              raised
            />
          </div>

          <FormCrearListaEspera
            visible={displayDialog}
            onHide={() => setDisplayDialog(false)}
            idCliente={idCliente}
            setDisplayDialog={setDisplayDialog}
            empresa={empresa}
            setEmpresa={setEmpresa}
            empresas={empresasOptions}
            tipoProducto={tipoProducto}
            setTipoProducto={setTipoProducto}
            tiposProducto={tiposProducto}
            setTiposProducto={setTiposProducto}
            baseUrl={baseUrl}
          />
        </>
      )}
    </>
  );
};

export default AgregarProducto;
